import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';


export class UserrolerelationApi extends SystemBaseApi {

  public get ControllerName(): any {
    return 'userrolerelation'
  }

  /**
   * 保存修改用户基本信息和关系表
   * @param param 
   */
  public saveUserRoleRelation(param) {

    return this.send(param, "saveUserRoleRelation", Methods.POST)

  }

  /**
   * 查询所有部门经理用户Id
   * @param subSystemId 
   */
  public getManagerUserId(subSystemId) {
    return this.send({ subSystemId: subSystemId }, "getManagerUserId", Methods.GET)
  }


  /**
   * 根据用户ID查询结构ID
   * @param subSystemId 
   */
  public getInstitutionIdByUserId(userId) {
    return this.send({ userId: userId }, "getInstitutionIdByUserId", Methods.GET)
  }

  /**
   * 根据项目id和子系统id，获取角色
   * @param projectId
   * @param subSystemId
   */
  public getUserRoleList(projectId, subSystemId) {
    return this.send({ projectId: projectId, subSystemId: subSystemId }, "getUserRoleList", Methods.GET)
  }

}